import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { APP_VERSION, VERSION_HISTORY, VersionInfo, ReleaseNote } from '../version';

@Injectable({
  providedIn: 'root'
})
export class VersionService {
  private currentVersion$ = new BehaviorSubject<VersionInfo>(APP_VERSION);
  private versionHistory$ = new BehaviorSubject<ReleaseNote[]>(VERSION_HISTORY);

  constructor() {
    console.log(`[VersionService] RARR System v${APP_VERSION.version} (${APP_VERSION.environment})`);
  }

  getCurrentVersion(): Observable<VersionInfo> {
    return this.currentVersion$.asObservable();
  }

  getVersionHistory(): Observable<ReleaseNote[]> {
    return this.versionHistory$.asObservable();
  }

  getVersionString(): string {
    return APP_VERSION.version;
  }

  getFullVersionString(): string {
    return `v${APP_VERSION.version} (${APP_VERSION.buildDate})`;
  }

  getBuildInfo(): string {
    return `Built on ${APP_VERSION.buildDate} for ${APP_VERSION.environment}`;
  }

  getLatestRelease(): ReleaseNote {
    return VERSION_HISTORY[0];
  }

  compareVersions(version1: string, version2: string): number {
    const v1Parts = version1.split('.').map(Number);
    const v2Parts = version2.split('.').map(Number);

    for (let i = 0; i < 3; i++) {
      if (v1Parts[i] > v2Parts[i]) return 1;
      if (v1Parts[i] < v2Parts[i]) return -1;
    }
    return 0;
  }

  isNewerVersion(version: string): boolean {
    return this.compareVersions(version, APP_VERSION.version) > 0;
  }

  getVersionBadgeClass(type: 'major' | 'minor' | 'patch'): string {
    switch (type) {
      case 'major': return 'bg-danger';
      case 'minor': return 'bg-success';
      case 'patch': return 'bg-info';
      default: return 'bg-secondary';
    }
  }

  getVersionIcon(type: 'major' | 'minor' | 'patch'): string {
    switch (type) {
      case 'major': return 'bi-rocket-takeoff';
      case 'minor': return 'bi-stars';
      case 'patch': return 'bi-wrench-adjustable';
      default: return 'bi-info-circle';
    }
  }
}
